import { createAsyncActionType } from './index';

export const TUTORS_LIST_GET = createAsyncActionType(
  'tutors',
  'TUTORS_LIST_GET'
);

export const COTUTORS_LIST_GET = createAsyncActionType(
  'tutors',
  'COTUTORS_LIST_GET'
);

// tabs
export const TUTOR_DISABLED_TAB_SET = '@@tutors/TUTOR_DISABLED_TAB_SET';
export const TUTOR_ACTIVE_TAB_SET = '@@tutors/TUTOR_ACTIVE_TAB_SET';
export const REDUCED_TABS_SET = '@@tutors/REDUCED_TABS_SET';
export const TABS_RESET = '@@tutors/TABS_RESET';

// overview
export const TAG_LIST_GET = createAsyncActionType('tutors', 'TAG_LIST_GET');
export const SURVEY_LIST_GET = createAsyncActionType(
  'tutors',
  'SURVEY_LIST_GET'
);

// activities
export const SECTIONS_SET = '@@tutors/SECTIONS_SET';
export const ADD_SECTION = '@@tutors/ADD_SECTION';
export const DEL_SECTION = '@@tutors/DEL_SECTION';
export const UPDATE_SECTION = '@@tutors/UPDATE_SECTION';
export const ADD_ACTIVITY = '@@tutors/ADD_ACTIVITY';
export const DEL_ACTIVITY = '@@tutors/DEL_ACTIVITY';
export const DEL_ACTIVITY_COPIES = '@@tutors/DEL_ACTIVITY_COPIES';
export const UPDATE_ACTIVITY = '@@tutors/UPDATE_ACTIVITY';
// activities - quiz
export const ADD_QUESTION = '@@tutors/ADD_QUESTION';
export const DEL_QUESTION = '@@tutors/DEL_QUESTION';
export const UPDATE_QUESTION = '@@tutors/UPDATE_QUESTION';
export const ADD_ANSWER = '@@tutors/ADD_ANSWER';
export const DEL_ANSWER = '@@tutors/DEL_ANSWER';
export const UPDATE_ANSWER = '@@tutors/UPDATE_ANSWER';
export const TEMP_QUIZ_SAVE = '@@tutors/TEMP_QUIZ_SAVE';
export const EDIT_QUIZ = '@@tutors/EDIT_QUIZ';
export const MODAL_QUIZ_RESET = '@@tutors/MODAL_QUIZ_RESET';
export const QUIZ_CREATE = createAsyncActionType('tutors', 'QUIZ_CREATE');
export const QUIZ_UPDATE = createAsyncActionType('tutors', 'QUIZ_UPDATE');
export const QUIZ_DELETE = createAsyncActionType('tutors', 'QUIZ_DELETE');
export const QUIZ_DETAILS_GET = createAsyncActionType(
  'tutors',
  'QUIZ_DETAILS_GET'
);
// activities - event sesison
export const SESSION_CREATE = createAsyncActionType('tutors', 'SESSION_CREATE');
export const SESSION_UPDATE = createAsyncActionType('tutors', 'SESSION_UPDATE');

// groups
export const USERS_RESET = '@@tutors/USERS_RESET';
export const USER_LIST_GET = createAsyncActionType('tutors', 'USER_LIST_GET');
export const GROUP_LIST_GET = createAsyncActionType('tutors', 'GROUP_LIST_GET');
export const ADD_NEW_GROUP = createAsyncActionType('tutors', 'ADD_NEW_GROUP');
export const EDIT_GROUP = createAsyncActionType('tutors', 'EDIT_GROUP');
export const GROUP_DELETE = createAsyncActionType('tutors', 'GROUP_DELETE');
export const REMOVE_NEW_GROUP = '@@tutors/REMOVE_NEW_GROUP';
export const GROUP_USERS_GET = createAsyncActionType(
  'tutors',
  'GROUP_USERS_GET'
);
export const GROUP_IMPORT_TEMPLATE_GET = createAsyncActionType(
  'tutors',
  'GROUP_IMPORT_TEMPLATE_GET'
);

// course
export const COURSE_TAB_SAVE = '@@tutors/COURSE_TAB_SAVE';
export const COURSE_SAVING = '@@tutors/COURSE_SAVING';
export const COURSE_CREATE = createAsyncActionType('tutors', 'COURSE_CREATE');
export const COURSE_UPDATE = createAsyncActionType('tutors', 'COURSE_UPDATE');
export const QUIZ_GROUP_DELETED = '@@tutors/QUIZ_GROUP_DELETED';
export const FILE_UPLOADED = '@@tutors/FILE_UPLOADED';
export const COURSE_CANCEL = createAsyncActionType('tutors', 'COURSE_CANCEL');
export const QUIZ_CREATION_RESET = '@@tutors/QUIZ_CREATION_RESET';
